'use client'
import { type ReactNode, useMemo } from 'react'
import { FeatureFlagsContext } from '@/features/shared/context/FeatureFlagsContext/FeatureFlagsContext'
import { defaultFlags } from '@/features/shared/services/FeatureFlags/constants'
import { useQueryFeatureFlags } from '@/features/shared/services/FeatureFlags/queries'

export const FeatureFlagsContextProvider = ({ children }: { children: ReactNode }) => {
  const { data, status } = useQueryFeatureFlags()
  const value = useMemo(() => {
    return { flags: data || defaultFlags, status }
  }, [data, status])

  return <FeatureFlagsContext value={value}>{children}</FeatureFlagsContext>
}
